export default __webpack_public_path__ + "static/media/rocket_anim_119.5b5c6bff.png";